/*********************
 * Mobillor Technologies Pvt. ltd. CONFIDENTIAL
 * __________________
 *
 *  Mobillor Technologies Pvt. Ltd.
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Mobillor Technologies Pvt. Ltd.
 * The intellectual and technical concepts contained
 * herein are proprietary to Mobillor Technologies Pvt. Ltd.
 * may be covered by Rebublic Of India and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Mobillor Technologies Pvt. Ltd.
 */

import { combineReducers } from "redux";
import {
  forgotPasswordReducer,
  validateOtpForForgotPasswordReducer,
} from "./authentication/forgot-password/forgotPasswordReducer";
import { loginReducer } from "./authentication/login/loginReducer";
import resetPasswordReducer from "./authentication/reset-password/resetPasswordReducer";
import {
  setNewPasswordReducer,
  setPasswordForNewUserReducer,
  setPasswordReducer,
} from "./authentication/set-password/setPasswordReducer";
import profileReducer from "./profile/profileReducer";
import {
  downloadGrnReportReducer,
  getGrnReportReducer,
} from "./reports/grn-report/grnReportReducer";

import {
  getExpandedFgReportHomeReducer,
  getExpandedGrnReportHomeReducer,
  getExpandedInventoryReportHomeReducer,
  getExpandedPicklistReportHomeReducer,
  getFgReducer,
  getFgReportHomeReducer,
  getGrnReportHomeReducer,
  getInventoryAgeingReportHomeReducer,
  getInventoryReducer,
  getItemStatusReportHomeReducer,
  getNavbarBoxesReducer,
  getPdiReducer,
  getPicklistAgeingReportHomeReducer,
  getPickupReducer,
  getRejectionReducer,
  getTop10ReportHomeReducer,
  getVendorApplicationReducer,
  getVendorMonthlyReducer,
  getVendorStatusCountsReducer,
  getVendorSubscriptionCountReducer,
  getWarehouseEfficiencyReportHomeReducer,
  getWarehouseOccupancyDataReducer,
  getWarehouseOccupancyReportHomeReducer,
  getWarehouseReducer,
  getWarehouseZonesHomeReducer,
  getYardReducer,
} from "./home/homeReducers";
import {
  editItemMasterReducer,
  getBinsByItemCodeReducer,
  getDownloadItemMasterWithPaginationReducer,
  getItemMasterReducer,
  getItemMasterWithPaginationReducer,
  getItemTypesReducer,
  getItemsDataForDownloadReducer,
  uploadCsvReducer,
} from "./item-master/itemMasterReducer";
import {
  getAcnReducer,
  getLevel1ByLevelReducer,
  getLevel1ByLevelSrcReducer,
  getLevel2ByLevelReducer,
  getLevel2ByLevelSrcReducer,
  getLevel3ByLevelReducer,
  getLevel3ByLevelSrcReducer,
  getLevel4ByLevelReducer,
  getLevel4ByLevelSrcReducer,
  getMappedActivityReducer,
} from "./location-mapping/item-location-mapping/itemLocationMappingReducer";

import {
  createWarehouseReducer,
  deliveryWarehouseReducer,
  getDownloadWarehouseReducer,
  getWarehouseByIdReducer,
  getWarehouseByTypeReducer,
  getWarehousesReducer,
  updateWarehouseReducer,
} from "./warehouses/warehousesReducer";

import {
  getAllGRNDataForDownloadReducer,
  getAllGRNReducer,
  getGrnItemsReducer,
  getGrnNotPrintedReducer,
  getGrpDownloadReducer,
  getLineItemsByGrnReducer,
} from "./grn/grnReducer";
import {
  individualPrintReducer,
  packagePrintReducer,
} from "./label-printing/labelPrintingReducer";
import {
  getSkuByItemCodeAndWarehouseCodeReducer,
  transferOrderIndividualPrintReducer,
  transferOrderPackagePrintReducer,
} from "./movement/create-transfer-order/createTransferOrderReducer";
import {
  getSkuForReprintReducer,
  getSuidForReprintReducer,
  reprintReducer,
} from "./reprint/reprintReducer";
import {
  addLocationReducer,
  deleteLocationReducer,
  downloadLocationsByWarehouseReducer,
  downloadWarehouseReducer,
  downloadZoneRackLocationReducer,
  getItemByLocationReducer,
  getLocationsByWarehouseAndZoneReducer,
  getLocationsByWarehouseReducer,
  getRacksByZoneAndCategoryReducer,
  getZonesByWarehouseForViewLocationReducer,
  levelsByWarehouseReducer,
} from "./view-location/viewLocationReducer";
import {
  addZoneToWarehouseReducer,
  getAllCategoriesReducer,
  getOpenBinsByWarehouseReducer,
  getOpenCategoryZonesByWarehouseReducer,
  getZonesByCategoryAndWarehouseReducer,
  getZonesByWarehouseReducer,
} from "./zones-and-categories/zoneCategoryReducer";

import { getCreateMaterialReturnOrderReducer } from "./movement/create-material-return-order/createMaterialReturnOrderReducer";
import { getMaterialReturnOrderReducer } from "./movement/material-return-order/materialReturnOrderReducer";

import devicesReducer from "./device-management/device-onboarding/deviceOnboardingReducer";
import { printersReducer } from "./device-management/printer-onboarding/printerOnboardingReducer";
import {
  allPrintersReducer,
  printerConfigReducer,
} from "./printer-config/printerConfigReducer";
import {
  createDepartmentReducer,
  deleteDepartmentReducer,
  getDepartmentsReducer,
  updateDepartmentReducer,
} from "./user-management/department/departmentReducer";
import { getLoginIdsReducer } from "./user-management/login-id/loginIdReducer";
// import { getModulesReducer } from "./user-management/modules/modulesReducer";
import {
  getModulesForEditReducer,
  getModulesForViewAccessReducer,
  getModulesForViewReducer,
  getModulesReducer,
  getSubModulesForCreateRoleReducer,
  getSubModulesForViewReducer,
  getSubModulesReducer,
} from "./modules/modulesReducer";
import {
  createUserDetailsReducer,
  deleteUserDetailsReducer,
  getRoleByClientReducer,
  getUsersDetailsReducer,
  updateUserDetailsReducer,
} from "./user-management/user-details/userDetailsReducer";
import {
  getAllClientsReducer,
  getAllRolesReducer,
  getModulesForEditRolesForUserReducer,
  getModulesForEditRolesReducer,
  getUserRolesByDepartment,
  getUserRolesReducer,
} from "./user-management/user-roles/userRolesReducer";

import {
  getModulesByRoleIdReducer,
  getSubModulesByRoleIdReducer,
} from "./user-modules/userModulesReducers";

import {
  createActivityReducer,
  deleteActivityReducer,
  getAllocatedActivityReducer,
  getCreatedActivityReducer,
  updateActivityReducer,
} from "./created-activity/createdActivityReducer";
import {
  getDocumentTypeReducer,
  getDocumentTypeWithPaginationReducer,
} from "./document-type/documentTypeReducer";
import {
  getRelationLocationReducer,
  mappedWarehousesReducer,
  unmappedWarehousesByLevelReducer,
} from "./relation-location/relationLocationReducer";
import {
  downloadRejectionsReportReducer,
  getRejectionsReportReducer,
} from "./reports/rejections-report/rejectionsReportReducer";

import {
  getAvailableQtyReducer,
  getDocumentNumberReducer,
  getDownloadPickListTrackingReducer,
  getGroupedPickListTrackingReducer,
  getItemByDocumentNoReducer,
  getItemsByPickListReducer,
  getPickListTrackingReducer,
  getUserReducer,
  releaseUserReducer,
} from "./picklist-tracking/picklistTrackingReducer";

import {
  createNewAssetReducer,
  deleteAssetReducer,
  getAssetTypesReducer,
  getAssetsReducer,
  getDownloadAssetsReducer,
  getMappedBinsByRifdReducer,
  getUnmappedBinsReducer,
  getUnmappedPalletsReducer,
  updateAssetReducer,
} from "./asset-master/assetMasterReducer";
import {
  downloadPicklistTrackingReportReducer,
  getPicklistTrackingReportReducer,
} from "./reports/picklist-tracking-report/picklistTrackingReportReducer";

import { otpReducer, otpValidateReducer } from "./otp/otpReducers";
import { registeredVendorsReducer } from "./registered-vendors/registeredVendorsReducers";
import { rejectedVendorsReducer } from "./rejected-vendors/rejectedVendorsReducers";
import { gstReducer, statusReducer } from "./status/statusReducers";
import {
  acceptVendorHandlerReducer,
  getLastFilledDataByVendorIdReducer,
  getPreviewReducer,
  getVendorByVendorIdReducer,
  getVendorIdReducer,
  getVendorsNotApprovedReducer,
  rejectVendorHandlerReducer,
  resendVendorRegistrationLinkReducer,
  updateEmailReducer,
  vendorRegistrationLinkReducer,
} from "./vendor-details/vendorDetailsReducers";

import {
  getBinsDownloadReducer,
  getBinsReducer,
  getBintypesReducer,
} from "./bin-pallet-master/bin-master/binMasterReducer";
import {
  getPalletTypesReducer,
  getPalletsDownloadReducer,
  getPalletsReducer,
} from "./bin-pallet-master/pallet-master/palletMasterReducer";
import {
  getCategoriesCreationDownloadReducer,
  getCategoriesReducer,
  getCategoriesWithPaginationReducer,
} from "./category-creation/categoryCreationReducer";
import {
  getCategoryItemMappingReducer,
  getCategoryItemMappingWithPaginationReducer,
  getWarehouseByMovementReducer,
} from "./category-item-mapping/categoryItemMappingReducer";
import {
  binsForPrintReducer,
  createDirectDemandReducer,
  deliveryPlantReducer,
  getDirectDemandReducer,
  getItemCodeByPOReducer,
  getItemsDetailsForASNReducer,
  getPurchaseOrdersForDemandReducer,
  packageDetailsReducer,
  packageTypeReducer,
  packetWeightReducer,
  partNoForPlannerReducer,
  partNoReducer,
  plantReducer,
  unloadingPointReducer,
  vendorsListForPlannerReducer,
} from "./direct-demand/directDemandReducer";
import {
  getDocTypeUserMappingReducer,
  getUnmappedDocumentTypeReducer,
  getUnmappedUsersDetailsReducer,
} from "./doctype-user-mapping/doctypeUserMappingReducer";
import {
  getAcnReducerForCategory,
  getCategoryItemsReducer,
  getCategoryLocationMappingReducer,
  getLevel1ByLevelReducerForCategory,
  getLevel2ByLevelForCategoryReducer,
  getLevel3ByLevelForCategoryReducer,
  getLevel4ByLevelForCategoryReducer,
} from "./location-mapping/category-location-mapping/categoryLocationMappingReducer";
import {
  createProductionPlanReducer,
  deleteProductionPlanReducer,
  editRequiredQtyReducer,
  getProductionPlanDownloadReducer,
  getProductionPlanReducer,
  getPublishedProductionPlanReducer,
  publishProductionPlanReducer,
} from "./production-plan/productionPlanReducer";
import {
  acceptPoReducer,
  acceptedPoReducer,
  createPurchaseOrderReducer,
  deletePurchaseOrderReducer,
  deliveryPlantForPOReducer,
  editPurchaseOrderReducer,
  getPurchaseOrderReducer,
  getReleasedPurchaseOrderReducer,
  getVendorCodeReducer,
  listOfItemsReducer,
  notAcceptedPurchasedOrdersReducer,
  publishPurchaseOrderReducer,
  unloadingPointForPOReducer,
} from "./purchase-order/purchaseOrderReducer";
import {
  getAllTransferOrdersDownloadReducer,
  getAllTransferOrdersReducer,
  getAvailableQtyForToReducer,
  getLevel1ByLevelForTransferOrderReducer,
  getLevel2ByLevelForTransferOrderReducer,
  getLevel3ByLevelForTransferOrderReducer,
  getLevel4ByLevelForTransferOrderReducer,
  getSuidsReducer,
  getWarehouseByItemCodeAndMovementReducer,
  splitQtyReducer,
} from "./transfer-order/transferOrderReducer";

import {
  asnDetailsDownloadReducer,
  asnDetailsReducer,
  binsReducer,
  lastAsnDetailsReducer,
  postCertificateViewReducer,
} from "./asn-details/asnDetailsReducers";

import {
  getFgCodeDocumentReducer,
  getFgItemsReducer,
  getFinishedGoodsForDownloadReducer,
  getFinishedGoodsReducer,
  getFinishedGoodsWithoutPaginationReducer,
  getGroupedFinishedGoodsReducer,
  getSfgFinishedGoodsReducer,
  getSfgReducer,
  getSuidsForFgReducer,
  getVinByFgCodeReducer,
  getVinsForFgReducer,
} from "./fg-transaction/fgTransactionReducer";

import {
  approveVinReducer,
  getAccessoriesByVinReducer,
  getFgCodeNoPaginationReducer,
  getFgCodeReducer,
  getSalesOrderForAFSReducer,
  getSalesOrderReducer,
  getVinByFgCodeForDispatchReducer,
  getVinStatusByTripNoReducer,
} from "./dispatch/dispatchReducer";

import {
  getAssemblyByAssemblyTypeReducer,
  getBomForPoReducer,
  getBomReducer,
  getDownloadBomDataReducer,
  getFgCodeByAssemblyTypeReducer,
  getItemForBomReducer,
  getItemsByFgCodeReducer,
} from "./bom/bomReducer";
import {
  getDownloadFgMasterReducer,
  getFgMasterReducer,
} from "./fg-master/fgMasterReducer";
import {
  acceptedQuarantinesReducer,
  acnTypeReducer,
  getSkuByDocumentNoReducer,
  getSkuByItemCodeReducer,
  getSkuStatusByLocationAndItemCodeReducer,
  itemCodeByWarehouseReducer,
  locationReducer,
  quarantineReducer,
  skuBySkuStatusReducer,
} from "./quarantine/quarantineReducer";
import {
  acceptedRejectionsReducer,
  getSkuByDocumentNoforRejectionsReducer,
  rejectionReducer,
} from "./rejections/rejectionReducer";
import {
  downloadAgeingReportReducer,
  getAgeingReportDownloadReducer,
  getAgeingReportReducer,
  getLocationsByAgeingReducer,
  getLocationsReducer,
} from "./reports/ageing-report/ageingReportReducer";
import {
  downloadWmsStockReducer,
  getWmsStockReducer,
} from "./reports/wms-stock/wmsStockReducer";
import {
  getDowloadStationMappingReducer,
  getItemsByStationReducer,
  getStationsByAssemblyTypeReducer,
} from "./station-and-item-mapping/stationAndItemReducer";
import {
  getItemsForWorkOrderReducer,
  getWorkOrderReducer,
} from "./work-order/workOrderReducer";

import {
  getBookingStationReducer,
  getConsumptionPendingReducer,
} from "./consumption-pending/consumptionPendingReducer";
import {
  getItemStatusReducer,
  getItemTypeReducer,
} from "./reports/item-status/itemStatusReducer";
import {
  downloadPicklistAgeingReportReducer,
  getAgeingParameterReducer,
  getMovementByDocReducer,
  getPicklistAgeingDownloadReducer,
  getPicklistAgeingReducer,
} from "./reports/picklist-ageing/picklistAgeingReducer";
import {
  downloadWarehouseOccupancyReducer,
  getWarehouseOccupancyReducer,
} from "./reports/warehouse-occupancy/warehouseOccupancyReducer";

import {
  getAllStationsReducer,
  getAssemblyMasterReducer,
  getAssemblyTypesReducer,
  getLocationsByStationReducer,
  getUnmappedStationsReducer,
} from "./assembly-master/assemblyMasterReducer";
import { mappedStationsByAssemblyReducer } from "./assembly-view/assemblyViewReducer";
import { getAsnGrnDependencyReducer } from "./reports/asn-grn-dependency/asnGrnDependencyReducers";
import { getBomReportsReducer } from "./reports/bom/bomReducer";
import {
  downloadConsumptionReportReducer,
  getConsumptionReportReducer,
} from "./reports/consumption/consumptionReducer";
import {
  getDocumenTypeTurnDownloadReducer,
  getDocumenTypeTurnReducer,
} from "./reports/document-type-turn-around-time/document-typeTurnReducer";
import { getMinMaxFailureReducer } from "./reports/min-max-failure/minMaxFailureReducers";
import {
  downloadQuarantineReportReducer,
  getQuarantineReportReducer,
} from "./reports/quarantine-report/quaratineReportReducer";
import {
  downloadStockAvailabilityReducer,
  getStockAvailabilityReducer,
} from "./reports/stock-availability/stockAvailabilityReducer";
import {
  getFailingMinimumTop10Reducer,
  getRTVTop10Reducer,
  getRejectedTop10Reducer,
  getTOTop10Reducer,
} from "./reports/top-10/top10Reducers";
import {
  getDailyVendorPerformanceReducer,
  getDateRangeReducer,
  getMonthlyVendorPerformanceReducer,
} from "./reports/vendor-performance/vendorPerformanceReducers";
import {
  getLocationsForAssemblyReducer,
  getWarehousesForAssemblyReducer,
} from "./shop-warehouse/shopWarehouseReducer";
import {
  getStationMasterReducer,
  getStationsByAssemblyIdForBomReducer,
} from "./station-assembly-master/station-master/stationMasterReducer";

import {
  getActiveCycleCountReducer,
  getCompletedCycleCountReducer,
  getCycleCountTypeReducer,
  getWarehousesByItemReducer,
} from "./cycle-count/cycleCountReducer";

import {
  listOfBinTypesReducer,
  vendorMasterMappingReducer,
} from "./supplier-portal-masters/supplierPortalMastersReducers";

import {
  getAccTypeReducer,
  getCcTypeReducer,
  getItemsByLocationReducer,
  getSuidsByDocumentNoReducer,
  getSuidsByLocationAndItemReducer,
  getUnplannedIssueDownloadReducer,
  getUnplannedIssueReducer,
} from "./unplanned-issue/unplannedIssueReducer";

// import { getConsumptionPendingReducer } from "./consumption-pending/consumptionPendingReducer";

import {
  getApproveMaterialRequestReducer,
  getSkuReducer,
  getSuidsForApproveMaterialRequestReducer,
  materialRequestReducer,
} from "./material-request/materialRequestReducer";
import {
  actionBySubModuleReducer,
  actionForMappingReducer,
  actionsForModuleReducer,
  apiForModuleReducer,
  componentForModuleReducer,
  // getAllClientsReducer,
  getUsersByClientReducer,
  moduleBySubmoduleReducer,
  modulesReducerForManagement,
  subModulesReducerForManagement,
} from "./module-management/moduleManagementReducer";
import {
  getFGModalReducer,
  getFGTypeReducer,
  getFgReportDownloadReducer,
  getFgReportReducer,
} from "./reports/fg-related-report/fgReportReducer";
import {
  getAdminModuleRolesReducer,
  getCreateRolesReducer,
} from "./user-management/client-roles/clientRolesReducer";
import { getComponentsReducer } from "./user-management/components-clients/componentsClientsReducer";
import { getUserDetailsForAdminReducer } from "./user-management/user-admin-details/userAdminDetailsReducer";

import { getDynamicColumnReducer } from "./dynamic-column/dynamicColumnReducer";

import {
  getCircularsForHomeReducer,
  getCircularsReducer,
} from "./circular/circularReducer";

import {
  getCalendarsForHomeReducer,
  getCalendarsReducer,
} from "./calendar/calendarReducer";
import {
  getCompletedTransactionsDownloadReducer,
  getCompletedTransactionsReducer,
  getRejectedTransactionsDownloadReducer,
  getRejectedTransactionsReducer,
  getTransactionsDownloadReducer,
  getTransactionsReducer,
} from "./transaction/transactionReducer";

import {
  getDocumentDownloadCenterReducer,
  getSingleDownloadReducer,
} from "./document-download-center/documentDownloadCenterReducer";

import { getPaymentReducer } from "./payment/paymentReducer";

import { getBannerReducer } from "./banner-logo/bannerLogoReducer";

import { getFaqDetailsReducer, getFaqReducer } from "./faq/faqReducer";

import {
  ocrSaveDataReducer,
  ocrUploadStructure1Reducer,
  ocrUploadStructure2Reducer,
  ocrUploadStructure3Reducer,
  ocrUploadStructure4Reducer,
  ocrUploadStructure5Reducer,
  ocrUploadStructure9Reducer,
} from "./ocr/ocrReducers";
import {
  getCompletedTicketsReducer,
  getInprogessStatusReducer,
  reportedTicketsReducer,
} from "./tickets/ticketsReducer";

import {
  acceptedPoClientReducer,
  acceptedPoVendorReducer,
  getAttechmentClientReducer,
  getClientRejectedPurchaseOrdersReducer,
  getVendorInvoiceReducer,
  getVendorPurchaseOrderReducer,
  getVendorRejectedPurchaseOrdersReducer,
} from "./purchase-order-new/purchaseOrderNewReducer";

import {
  paymentStatusReducer,
  reviewInvoiceReducer,
  unReviewInvoiceReducer,
  websocketReducer,
} from "./po-invoice/poInvoiceReducers";

import {
  dailyDemandForDownloadReducer,
  dailyDemandReducer,
  monthlyDemandDownloadReducer,
  monthlyDemandReducer,
  unConfirmedMonthlyDemandReducer,
  vendorsListForPlannerWithPaginationReducer,
} from "./new-demand/newDemandReducers";

import {
  vendorDataForDownloadReducer,
  vendorUploadReducer,
} from "./vendor-upload/vendorUploadReducer";

import {
  getLocationsForMachineReducer,
  getMachineCenterForDropDownReducer,
  getMachineCenterReducer,
  getMappedMachinesReducer,
  getWorkCenterReducer,
} from "./machine-center/machineCenterReducer";
import { getOperationMachineMapReducer } from "./operation-machine-map/operationsMachineMapReducer";
import {
  getOperationsByPoReducer,
  getOperationsForDropDownReducer,
  getOperationsReducer,
} from "./operations/operationsReducer";
import {
  getUserMachineReducer,
  getUsersForPoReducer,
} from "./userMachineMapping/userMachineReducer";

import {
  createNewResourceGroupReducer,
  deleteResourceGroupReducer,
  getLocationsForResourceGroupReducer,
  getResourceGroupReducer,
  updateResourceGroupReducer,
} from "./resource-group-screen/resourceGroupScreenReducer";

import {
  getCompletedPoListingReducer,
  getConsumedSuidsReducer,
  getOperationsListByPOReducer,
  getPoListingReducer,
  getPoListingWithoutPaginationReducer,
  getPoProcessLogReducer,
  getPoProcessLogReportsReducer,
  getRoutingInfoByPOReducer,
} from "./po-management/poManagementReducer";

import {
  getLabelsReducer,
  getLabelsWithPaginationReducer,
  getPrintersForLabelCreationReducer,
} from "./afs-label-creation/labelCreationReducer";

import { getComplianceReducer } from "./dppSystem/compliance/complianceReducer";
import {
  getCustodyReducer,
  getFromEnitityReducer,
  getLocationFromReducer,
  getPOnumberFGReducer,
  getPOnumberInsertReducer,
  getPOnumberReducer,
} from "./dppSystem/custody/custodyReducer";
import {
  getDppDocumentsImageReducer,
  getDppDocumentsReducer,
} from "./dppSystem/documents-dpp/documentsReducer";
import { getDppDurabilityReducer } from "./dppSystem/durability/durabilityReducer";
import { getPackagingReducer } from "./dppSystem/packaging/packagingReducer";
import {
  getDPPReducer,
  getFgOperationReducer,
  getIndustryTypeReducer,
  getManufacturerDetailsReducer,
  getPassPortReducer,
  getPassPortViewReducer,
  getProductSpecificationReducer,
  getProductVariantReducer,
  getRmTraceReducer,
  getSupplierTypeReducer,
  getUsersForFGReducer,
} from "./dppSystem/passport/passPortReducer";
import { getRepairValueReducer } from "./dppSystem/repairValue/repairValueReducer";
import {
  getRepairCenterReducer,
  getReturnsReducer,
} from "./dppSystem/returns/returnsReducer";
import {
  getMappedSKUReducer,
  getShipmentReducer,
  getSkuByItemIdReducer,
  getSkuBySkuTypeReducer,
  getSkuManagementReducer,
  getSkuManagementWithoutPaginationReducer,
} from "./packaging-workflow-management/packagingWorkflowManagementReducer";

import {
  createCareAndUseReducer,
  deleteCareAndUseReducer,
  editCareAndUseReducer,
  getAllCareAndUseReducer,
  getOneCareAndUseReducer,
} from "./dppSystem/care&Use-Instructions/care&UseInstructionsReducers";

import { getTensileTestReducer } from "./product-testing/productTesingReducers";

import { getChemicalAnalysisReducer } from "./dppSystem/chemicalAnalysis/chemicalAnalysisReducer";
import { getHardnessTestReducer } from "./dppSystem/hardness-test/hardnessReducers";
import { getManufacturerReducer } from "./dppSystem/manufacturer/manufacturerReducer";
import { getNotchImpactTestReducer } from "./dppSystem/notchImpact-Test/notchImpactTestReducer";

import {
  createIndustryReducer,
  deleteIndustryReducer,
  editIndustryReducer,
  getAllIndustryReducer,
  getOneIndustryReducer,
} from "./dppSystem/industry-master/industryMasterReducer";

import {
  createSupplierReducer,
  deleteSupplierReducer,
  editSupplierReducer,
  getAllSupplierReducer,
  getOneSupplierReducer,
} from "./dppSystem/supplier/supplierReducer";

import {
  getAllDataForDppReducer,
  getChainOfCustodyReducer,
  getDurabilityReducer,
  getEnvironmentalReducer,
  getManufacturingReducer,
  getPackagingWasteManagementReducer,
  getParentDppCodesReducer,
  getParentRawCodesReducer,
  getProductsListForDppReducer,
  getRawMaterialReducer,
  getRepairMaintenanceReducer,
  getTechnicalDocumentsReducer,
  getTreeMapReducer
} from "./dpp/dppReducer";

import { getThermalStabilityTestReducer } from "./dppSystem/thermal-stability-test/thermalStabilityTestReducer";

import { getUsageHistoryReducer } from "./dppSystem/usage-history/UsageHistoryReducer";

import {
  getAllSessionsReducer,
  getSessionHistoryReducer,
  sendMessageReducer,
} from "./ai-chatBot/aiChatBotReducers";

import { getWoProcessLogReportReducer } from "./reports/wo-process-log/woProcessLogReducer";

import { getUploadErrorsReducer } from "./dppSystem/upload-error-showing/uploadTableReducer";

const rootReducer = combineReducers({
  vendorsListForPlannerWithPaginationReducer:
    vendorsListForPlannerWithPaginationReducer,
  monthlyDemandDownloadReducer: monthlyDemandDownloadReducer,
  dailyDemandReducer: dailyDemandReducer,
  unConfirmedMonthlyDemandReducer: unConfirmedMonthlyDemandReducer,
  monthlyDemandReducer: monthlyDemandReducer,
  dailyDemandForDownloadReducer: dailyDemandForDownloadReducer,
  setPasswordReducer: setPasswordReducer,
  login: loginReducer,
  resetPassword: resetPasswordReducer,
  getCompletedTransactionsDownloadReducer:
    getCompletedTransactionsDownloadReducer,
  getSalesOrderForAFSReducer: getSalesOrderForAFSReducer,
  getRejectedTransactionsDownloadReducer:
    getRejectedTransactionsDownloadReducer,
  getUnplannedIssueDownloadReducer: getUnplannedIssueDownloadReducer,
  getTransactionsDownloadReducer: getTransactionsDownloadReducer,
  setPasswordForNewUserReducer: setPasswordForNewUserReducer,
  setNewPasswordReducer: setNewPasswordReducer,
  forgotPassword: forgotPasswordReducer,
  validateOtpForForgotPasswordReducer: validateOtpForForgotPasswordReducer,
  profile: profileReducer,
  printersReducer: printersReducer,
  subModulesReducerForManagement: subModulesReducerForManagement,
  modulesReducerForManagement: modulesReducerForManagement,

  componentForModuleReducer: componentForModuleReducer,
  actionsForModuleReducer: actionsForModuleReducer,
  moduleBySubmoduleReducer: moduleBySubmoduleReducer,
  apiForModuleReducer: apiForModuleReducer,
  actionBySubModuleReducer: actionBySubModuleReducer,
  actionForMappingReducer: actionForMappingReducer,
  getAllClientsReducer: getAllClientsReducer,
  getUsersByClientReducer: getUsersByClientReducer,
  allPrintersReducer: allPrintersReducer,
  printerConfigReducer: printerConfigReducer,
  devicesReducer: devicesReducer,
  getDepartmentsReducer: getDepartmentsReducer,
  createDepartmentReducer: createDepartmentReducer,
  getStationsByAssemblyIdForBomReducer: getStationsByAssemblyIdForBomReducer,
  updateDepartmentReducer: updateDepartmentReducer,
  deleteDepartmentReducer: deleteDepartmentReducer,

  getFinishedGoodsForDownloadReducer: getFinishedGoodsForDownloadReducer,
  getAllRolesReducer: getAllRolesReducer,
  getUserRolesByDepartment: getUserRolesByDepartment,
  getModulesReducer: getModulesReducer,
  getSubModulesReducer: getSubModulesReducer,
  getSubModulesForViewReducer: getSubModulesForViewReducer,
  getModulesForViewReducer: getModulesForViewReducer,
  getModulesForEditReducer: getModulesForEditReducer,
  getSubModulesForCreateRoleReducer: getSubModulesForCreateRoleReducer,
  getUsersDetailsReducer: getUsersDetailsReducer,
  createUserDetailsReducer: createUserDetailsReducer,
  updateUserDetailsReducer: updateUserDetailsReducer,
  deleteUserDetailsReducer: deleteUserDetailsReducer,
  getVinByFgCodeForDispatchReducer: getVinByFgCodeForDispatchReducer,
  getWarehouseByTypeReducer: getWarehouseByTypeReducer,
  partNoReducer: partNoReducer,
  plantReducer: plantReducer,
  asnDetailsReducer: asnDetailsReducer,
  binsReducer: binsReducer,
  lastAsnDetailsReducer: lastAsnDetailsReducer,
  asnDetailsDownloadReducer: asnDetailsDownloadReducer,
  packageTypeReducer: packageTypeReducer,
  packageDetailsReducer: packageDetailsReducer,
  deliveryPlantReducer: deliveryPlantReducer,
  unloadingPointReducer: unloadingPointReducer,
  packetWeightReducer: packetWeightReducer,
  binsForPrintReducer: binsForPrintReducer,
  getLoginIdsReducer: getLoginIdsReducer,
  getVinsForFgReducer: getVinsForFgReducer,
  getInventoryHomePage: getInventoryReducer,
  getPickupListHomePage: getPickupReducer,
  warehouseOccupancyHomePage: getWarehouseReducer,
  getYardOccupancyHomePage: getYardReducer,
  getFinishedGoodsHomePage: getFgReducer,
  getPdiHomePage: getPdiReducer,
  getRejectionHomePage: getRejectionReducer,
  itemMaster: getItemMasterReducer,
  itemMasterWithPagination: getItemMasterWithPaginationReducer,
  getItemTypesReducer: getItemTypesReducer,
  binsByItemCode: getBinsByItemCodeReducer,
  uploadCsvState: uploadCsvReducer,
  getItemsDataForDownloadReducer: getItemsDataForDownloadReducer,
  editItemMaster: editItemMasterReducer,
  downloadGrnReportReducer: downloadGrnReportReducer,
  getGrnReportReducer: getGrnReportReducer,
  downloadQuarantineReportReducer: downloadQuarantineReportReducer,
  getQuarantineReportReducer: getQuarantineReportReducer,
  locationsByWarehouse: getLocationsByWarehouseReducer,
  locationsByWarehouseAndZone: getLocationsByWarehouseAndZoneReducer,
  deleteLocation: deleteLocationReducer,
  addLocationToWarehouse: addLocationReducer,
  item: getItemByLocationReducer,
  warehouses: getWarehousesReducer,
  warehouseById: getWarehouseByIdReducer,
  updateWarehouse: updateWarehouseReducer,
  deliveryWarehouse: deliveryWarehouseReducer,
  createWarehouseReducer: createWarehouseReducer,
  getMappedActivityReducer: getMappedActivityReducer,
  getUnmappedDocumentTypeReducer: getUnmappedDocumentTypeReducer,
  getUnmappedUsersDetailsReducer: getUnmappedUsersDetailsReducer,
  skuForReprint: getSkuForReprintReducer,
  reprintReducer: reprintReducer,
  skuByItemCodeAndWarehouseCode: getSkuByItemCodeAndWarehouseCodeReducer,
  transferOrders: getAllTransferOrdersReducer,
  getCreateMaterialReturnOrderReducer: getCreateMaterialReturnOrderReducer,
  getMaterialReturnOrderReducer: getMaterialReturnOrderReducer,

  zonesByCategoryAndWarehouse: getZonesByCategoryAndWarehouseReducer,
  openCategoryZones: getOpenCategoryZonesByWarehouseReducer,
  zonesByWarehouse: getZonesByWarehouseReducer,
  getRacksByZoneAndCategoryReducer: getRacksByZoneAndCategoryReducer,
  getLevel1ByLevelReducer: getLevel1ByLevelReducer,
  getLevel2ByLevelReducer: getLevel2ByLevelReducer,
  getLevel3ByLevelReducer: getLevel3ByLevelReducer,
  getLevel4ByLevelReducer: getLevel4ByLevelReducer,
  getAcnReducer: getAcnReducer,
  openBinsByWarehouse: getOpenBinsByWarehouseReducer,
  allCategories: getAllCategoriesReducer,
  addZoneToWarehouse: addZoneToWarehouseReducer,
  allGRN: getAllGRNReducer,
  getAllGRNDataForDownloadReducer: getAllGRNDataForDownloadReducer,
  lineItemsByGrn: getLineItemsByGrnReducer,
  individualLabelPrint: individualPrintReducer,
  packageLabelPrint: packagePrintReducer,
  transferOrderIndividualPrint: transferOrderIndividualPrintReducer,
  transferOrderPackagePrint: transferOrderPackagePrintReducer,

  downloadWarehouseReducer: downloadWarehouseReducer,
  downloadZoneRackLocationReducer: downloadZoneRackLocationReducer,

  getModulesByRoleIdReducer: getModulesByRoleIdReducer,
  getSubModulesByRoleIdReducer: getSubModulesByRoleIdReducer,

  getRelationLocationReducer: getRelationLocationReducer,
  unmappedWarehousesByLevelReducer: unmappedWarehousesByLevelReducer,
  mappedWarehousesReducer: mappedWarehousesReducer,
  getCreatedActivityReducer: getCreatedActivityReducer,
  createActivityReducer: createActivityReducer,
  deleteActivityReducer: deleteActivityReducer,
  updateActivityReducer: updateActivityReducer,
  downloadWmsStockReducer: downloadWmsStockReducer,

  getDocumentTypeReducer: getDocumentTypeReducer,
  getDocumentTypeWithPaginationReducer: getDocumentTypeWithPaginationReducer,
  getAllocatedActivityReducer: getAllocatedActivityReducer,
  getModulesForViewAccessReducer: getModulesForViewAccessReducer,
  getModulesForViewAccessReducer: getModulesForViewAccessReducer,
  getModulesForEditRolesForUserReducer: getModulesForEditRolesForUserReducer,
  getRejectionsReportReducer: getRejectionsReportReducer,
  downloadRejectionsReportReducer: downloadRejectionsReportReducer,
  getGrnItemsReducer: getGrnItemsReducer,
  getGrnNotPrintedReducer: getGrnNotPrintedReducer,

  getPickListTrackingReducer: getPickListTrackingReducer,
  getGroupedPickListTrackingReducer: getGroupedPickListTrackingReducer,
  getItemsByPickListReducer: getItemsByPickListReducer,
  getUserReducer: getUserReducer,
  releaseUserReducer: releaseUserReducer,
  getDocumentNumberReducer: getDocumentNumberReducer,
  getItemByDocumentNoReducer: getItemByDocumentNoReducer,
  getAvailableQtyReducer: getAvailableQtyReducer,
  getAssetsReducer: getAssetsReducer,
  updateAssetReducer: updateAssetReducer,
  createNewAssetReducer: createNewAssetReducer,
  deleteAssetReducer: deleteAssetReducer,
  getAssetTypesReducer: getAssetTypesReducer,
  getLocationsByStationReducer: getLocationsByStationReducer,
  getAllStationsReducer: getAllStationsReducer,
  rejectedVendorsReducer: rejectedVendorsReducer,
  registeredVendorsReducer: registeredVendorsReducer,
  statusReducer: statusReducer,
  updateEmailReducer: updateEmailReducer,
  vendorRegistrationLinkReducer: vendorRegistrationLinkReducer,
  resendVendorRegistrationLinkReducer: resendVendorRegistrationLinkReducer,
  getVendorByVendorIdReducer: getVendorByVendorIdReducer,
  getVendorsNotApprovedReducer: getVendorsNotApprovedReducer,
  acceptVendorHandlerReducer: acceptVendorHandlerReducer,
  rejectVendorHandlerReducer: rejectVendorHandlerReducer,
  getPreviewReducer: getPreviewReducer,
  getVendorIdReducer: getVendorIdReducer,
  otpValidateReducer: otpValidateReducer,
  otpReducer: otpReducer,

  getPicklistTrackingReportReducer: getPicklistTrackingReportReducer,
  downloadPicklistTrackingReportReducer: downloadPicklistTrackingReportReducer,
  getBinsReducer: getBinsReducer,
  getBintypesReducer: getBintypesReducer,
  getPalletsReducer: getPalletsReducer,
  getPalletTypesReducer: getPalletTypesReducer,
  getUnmappedBinsReducer: getUnmappedBinsReducer,
  getUnmappedPalletsReducer: getUnmappedPalletsReducer,
  getDirectDemandReducer: getDirectDemandReducer,
  createDirectDemandReducer: createDirectDemandReducer,
  getProductionPlanReducer: getProductionPlanReducer,
  createProductionPlanReducer: createProductionPlanReducer,
  editRequiredQtyReducer: editRequiredQtyReducer,
  deleteProductionPlanReducer: deleteProductionPlanReducer,
  getPurchaseOrderReducer: getPurchaseOrderReducer,
  deliveryPlantForPOReducer: deliveryPlantForPOReducer,
  unloadingPointForPOReducer: unloadingPointForPOReducer,
  createPurchaseOrderReducer: createPurchaseOrderReducer,
  editPurchaseOrderReducer: editPurchaseOrderReducer,
  deletePurchaseOrderReducer: deletePurchaseOrderReducer,
  publishProductionPlanReducer: publishProductionPlanReducer,
  getPublishedProductionPlanReducer: getPublishedProductionPlanReducer,
  publishPurchaseOrderReducer: publishPurchaseOrderReducer,
  acceptedPoReducer: acceptedPoReducer,
  listOfItemsReducer: listOfItemsReducer,
  notAcceptedPurchasedOrdersReducer: notAcceptedPurchasedOrdersReducer,
  getVendorCodeReducer: getVendorCodeReducer,
  acceptPoReducer: acceptPoReducer,

  getReleasedPurchaseOrderReducer: getReleasedPurchaseOrderReducer,
  getCategoriesReducer: getCategoriesReducer,
  getCategoriesWithPaginationReducer: getCategoriesWithPaginationReducer,
  getCategoryItemMappingReducer: getCategoryItemMappingReducer,
  getCategoryItemMappingWithPaginationReducer:
    getCategoryItemMappingWithPaginationReducer,
  getDocTypeUserMappingReducer: getDocTypeUserMappingReducer,
  getCategoryLocationMappingReducer: getCategoryLocationMappingReducer,
  getLevel1ByLevelReducerForCategory: getLevel1ByLevelReducerForCategory,
  getLevel2ByLevelForCategoryReducer: getLevel2ByLevelForCategoryReducer,
  getLevel3ByLevelForCategoryReducer: getLevel3ByLevelForCategoryReducer,
  getLevel4ByLevelForCategoryReducer: getLevel4ByLevelForCategoryReducer,
  getLevel1ByLevelSrcReducer: getLevel1ByLevelSrcReducer,
  getLevel2ByLevelSrcReducer: getLevel2ByLevelSrcReducer,
  getLevel3ByLevelSrcReducer: getLevel3ByLevelSrcReducer,
  getLevel4ByLevelSrcReducer: getLevel4ByLevelSrcReducer,
  getAcnReducerForCategory: getAcnReducerForCategory,
  getCategoryItemsReducer: getCategoryItemsReducer,
  getSuidsReducer: getSuidsReducer,
  getAvailableQtyForToReducer: getAvailableQtyForToReducer,
  getFinishedGoodsReducer: getFinishedGoodsReducer,
  getGroupedFinishedGoodsReducer: getGroupedFinishedGoodsReducer,
  getVinByFgCodeReducer: getVinByFgCodeReducer,
  getSuidsForFgReducer: getSuidsForFgReducer,
  getFgItemsReducer: getFgItemsReducer,
  getFgCodeDocumentReducer: getFgCodeDocumentReducer,
  salesOrder: getSalesOrderReducer,
  approveVin: approveVinReducer,
  vinStatus: getVinStatusByTripNoReducer,
  accessoriesByVin: getAccessoriesByVinReducer,
  rejectionReducer: rejectionReducer,
  acceptedRejectionsReducer: acceptedRejectionsReducer,
  quarantineReducer: quarantineReducer,
  acceptedQuarantinesReducer: acceptedQuarantinesReducer,
  getFgCodeReducer: getFgCodeReducer,
  getFgCodeNoPaginationReducer: getFgCodeNoPaginationReducer,
  getWorkOrderReducer: getWorkOrderReducer,
  getItemsForWorkOrderReducer: getItemsForWorkOrderReducer,
  getFgMasterReducer: getFgMasterReducer,
  getStationsByAssemblyTypeReducer: getStationsByAssemblyTypeReducer,
  getItemsByStationReducer: getItemsByStationReducer,
  getBomReducer: getBomReducer,
  getItemsByFgCodeReducer: getItemsByFgCodeReducer,
  getItemForBomReducer: getItemForBomReducer,
  getWmsStockReducer: getWmsStockReducer,
  getPicklistAgeingReducer: getPicklistAgeingReducer,
  getAgeingParameterReducer: getAgeingParameterReducer,
  downloadPicklistAgeingReportReducer: downloadPicklistAgeingReportReducer,
  getPicklistAgeingDownloadReducer: getPicklistAgeingDownloadReducer,
  getItemTypeReducer: getItemTypeReducer,
  getWarehouseOccupancyReducer: getWarehouseOccupancyReducer,
  downloadWarehouseOccupancyReducer: downloadWarehouseOccupancyReducer,
  getDocumenTypeTurnReducer: getDocumenTypeTurnReducer,
  getDocumenTypeTurnDownloadReducer: getDocumenTypeTurnDownloadReducer,
  getItemStatusReducer: getItemStatusReducer,
  getAgeingReportReducer: getAgeingReportReducer,
  downloadAgeingReportReducer: downloadAgeingReportReducer,
  getAgeingReportDownloadReducer: getAgeingReportDownloadReducer,
  getLocationsByAgeingReducer: getLocationsByAgeingReducer,
  getLocationsReducer: getLocationsReducer,
  getMovementByDocReducer: getMovementByDocReducer,
  mappedStationsByAssemblyReducer: mappedStationsByAssemblyReducer,
  getLocationsForAssemblyReducer: getLocationsForAssemblyReducer,
  getWarehousesForAssemblyReducer: getWarehousesForAssemblyReducer,
  getAssemblyMasterReducer: getAssemblyMasterReducer,
  getStationMasterReducer: getStationMasterReducer,
  getAssemblyTypesReducer: getAssemblyTypesReducer,
  getTransactionsReducer: getTransactionsReducer,
  getRejectedTransactionsReducer: getRejectedTransactionsReducer,
  getCompletedTransactionsReducer: getCompletedTransactionsReducer,
  getFgCodeByAssemblyTypeReducer: getFgCodeByAssemblyTypeReducer,
  getAssemblyByAssemblyTypeReducer: getAssemblyByAssemblyTypeReducer,
  getWarehouseByMovementReducer: getWarehouseByMovementReducer,
  getMappedBinsByRifdReducer: getMappedBinsByRifdReducer,
  itemCodeByWarehouseReducer: itemCodeByWarehouseReducer,
  locationReducer: locationReducer,
  skuBySkuStatusReducer: skuBySkuStatusReducer,
  getSkuStatusByLocationAndItemCodeReducer:
    getSkuStatusByLocationAndItemCodeReducer,
  getSkuByItemCodeReducer: getSkuByItemCodeReducer,
  getSkuByDocumentNoReducer: getSkuByDocumentNoReducer,
  getSkuByDocumentNoforRejectionsReducer:
    getSkuByDocumentNoforRejectionsReducer,
  acnTypeReducer: acnTypeReducer,
  getActiveCycleCountReducer: getActiveCycleCountReducer,
  getCompletedCycleCountReducer: getCompletedCycleCountReducer,
  getCycleCountTypeReducer: getCycleCountTypeReducer,
  getWarehousesByItemReducer: getWarehousesByItemReducer,
  getUnplannedIssueReducer: getUnplannedIssueReducer,
  getItemsByLocationReducer: getItemsByLocationReducer,
  getSuidsByLocationAndItemReducer: getSuidsByLocationAndItemReducer,
  getSuidsByDocumentNoReducer: getSuidsByDocumentNoReducer,
  getFinishedGoodsWithoutPaginationReducer:
    getFinishedGoodsWithoutPaginationReducer,
  getUnmappedStationsReducer: getUnmappedStationsReducer,

  partNoForPlannerReducer: partNoForPlannerReducer,

  vendorsListForPlannerReducer: vendorsListForPlannerReducer,

  vendorMasterMappingReducer: vendorMasterMappingReducer,
  listOfBinTypesReducer: listOfBinTypesReducer,
  getItemsDetailsForASNReducer: getItemsDetailsForASNReducer,
  getPurchaseOrdersForDemandReducer: getPurchaseOrdersForDemandReducer,
  getItemCodeByPOReducer: getItemCodeByPOReducer,
  getAccTypeReducer: getAccTypeReducer,
  getCcTypeReducer: getCcTypeReducer,

  getConsumptionPendingReducer: getConsumptionPendingReducer,

  getBookingStationReducer: getBookingStationReducer,
  levelsByWarehouseReducer: levelsByWarehouseReducer,
  getComponentsReducer: getComponentsReducer,
  SkuReducer: getSkuReducer,
  materialRequestReducer: materialRequestReducer,
  getApproveMaterialRequestReducer: getApproveMaterialRequestReducer,
  getSuidsForApproveMaterialRequestReducer:
    getSuidsForApproveMaterialRequestReducer,
  getZonesByWarehouseForViewLocationReducer:
    getZonesByWarehouseForViewLocationReducer,
  getAsnGrnDependencyReducer: getAsnGrnDependencyReducer,
  getMinMaxFailureReducer: getMinMaxFailureReducer,
  getDailyVendorPerformanceReducer: getDailyVendorPerformanceReducer,
  getDateRangeReducer: getDateRangeReducer,
  getMonthlyVendorPerformanceReducer: getMonthlyVendorPerformanceReducer,
  postCertificateViewReducer: postCertificateViewReducer,
  getFailingMinimumTop10Reducer: getFailingMinimumTop10Reducer,
  getRTVTop10Reducer: getRTVTop10Reducer,
  getRejectedTop10Reducer: getRejectedTop10Reducer,
  getTOTop10Reducer: getTOTop10Reducer,
  getSfgReducer: getSfgReducer,
  getSfgFinishedGoodsReducer: getSfgFinishedGoodsReducer,
  getDownloadWarehouseReducer: getDownloadWarehouseReducer,
  getDownloadPickListTrackingReducer: getDownloadPickListTrackingReducer,
  getDowloadStationMappingReducer: getDowloadStationMappingReducer,
  getDownloadBomDataReducer: getDownloadBomDataReducer,
  getDownloadFgMasterReducer: getDownloadFgMasterReducer,
  getDownloadItemMasterWithPaginationReducer:
    getDownloadItemMasterWithPaginationReducer,
  getDownloadAssetsReducer: getDownloadAssetsReducer,
  getGrpDownloadReducer: getGrpDownloadReducer,
  getBinsDownloadReducer: getBinsDownloadReducer,
  getPalletsDownloadReducer: getPalletsDownloadReducer,

  getFgReportReducer: getFgReportReducer,
  getFGTypeReducer: getFGTypeReducer,
  getFGModalReducer: getFGModalReducer,
  getFgReportDownloadReducer: getFgReportDownloadReducer,
  getConsumptionReportReducer: getConsumptionReportReducer,
  downloadConsumptionReportReducer: downloadConsumptionReportReducer,
  getStockAvailabilityReducer: getStockAvailabilityReducer,
  downloadStockAvailabilityReducer: downloadStockAvailabilityReducer,
  getBomReportsReducer: getBomReportsReducer,
  getAdminModuleRolesReducer: getAdminModuleRolesReducer,
  getUserDetailsForAdminReducer: getUserDetailsForAdminReducer,
  getModulesForEditRolesReducer: getModulesForEditRolesReducer,
  getUserRolesReducer: getUserRolesReducer,

  getRoleByClientReducer: getRoleByClientReducer,
  getCreateRolesReducer: getCreateRolesReducer,
  getCategoriesCreationDownloadReducer: getCategoriesCreationDownloadReducer,

  getDynamicColumnReducer: getDynamicColumnReducer,

  splitQtyReducer: splitQtyReducer,

  getLevel1ByLevelForTransferOrderReducer:
    getLevel1ByLevelForTransferOrderReducer,
  getLevel2ByLevelForTransferOrderReducer:
    getLevel2ByLevelForTransferOrderReducer,
  getLevel3ByLevelForTransferOrderReducer:
    getLevel3ByLevelForTransferOrderReducer,
  getLevel4ByLevelForTransferOrderReducer:
    getLevel4ByLevelForTransferOrderReducer,
  getWarehouseByItemCodeAndMovementReducer:
    getWarehouseByItemCodeAndMovementReducer,
  getAllTransferOrdersDownloadReducer: getAllTransferOrdersDownloadReducer,
  getSuidForReprintReducer: getSuidForReprintReducer,

  getCircularsForHomeReducer: getCircularsForHomeReducer,
  getCircularsReducer: getCircularsReducer,
  getCalendarsReducer: getCalendarsReducer,
  getCalendarsForHomeReducer: getCalendarsForHomeReducer,
  getNavbarBoxesReducer: getNavbarBoxesReducer,
  getVendorStatusCountsReducer: getVendorStatusCountsReducer,
  getWarehouseOccupancyReportHomeReducer:
    getWarehouseOccupancyReportHomeReducer,
  getGrnReportHomeReducer: getGrnReportHomeReducer,
  getFgReportHomeReducer: getFgReportHomeReducer,
  getItemStatusReportHomeReducer: getItemStatusReportHomeReducer,
  getInventoryAgeingReportHomeReducer: getInventoryAgeingReportHomeReducer,
  getPicklistAgeingReportHomeReducer: getPicklistAgeingReportHomeReducer,
  getTop10ReportHomeReducer: getTop10ReportHomeReducer,
  getWarehouseEfficiencyReportHomeReducer:
    getWarehouseEfficiencyReportHomeReducer,

  getDocumentDownloadCenterReducer: getDocumentDownloadCenterReducer,
  getSingleDownloadReducer: getSingleDownloadReducer,

  getPaymentReducer: getPaymentReducer,

  getBannerReducer: getBannerReducer,

  getFaqReducer: getFaqReducer,
  getFaqDetailsReducer: getFaqDetailsReducer,
  gstReducer: gstReducer,
  getWarehouseOccupancyDataReducer: getWarehouseOccupancyDataReducer,
  getWarehouseZonesHomeReducer: getWarehouseZonesHomeReducer,
  getExpandedGrnReportHomeReducer: getExpandedGrnReportHomeReducer,
  getExpandedFgReportHomeReducer: getExpandedFgReportHomeReducer,
  getExpandedInventoryReportHomeReducer: getExpandedInventoryReportHomeReducer,
  getExpandedPicklistReportHomeReducer: getExpandedPicklistReportHomeReducer,
  ocrUploadStructure1Reducer: ocrUploadStructure1Reducer,
  ocrUploadStructure2Reducer: ocrUploadStructure2Reducer,
  ocrUploadStructure3Reducer: ocrUploadStructure3Reducer,
  ocrUploadStructure4Reducer: ocrUploadStructure4Reducer,
  ocrUploadStructure5Reducer: ocrUploadStructure5Reducer,
  ocrUploadStructure9Reducer: ocrUploadStructure9Reducer,

  ocrSaveDataReducer: ocrSaveDataReducer,
  reportedTicketsReducer: reportedTicketsReducer,
  getInprogessStatusReducer: getInprogessStatusReducer,
  getCompletedTicketsReducer: getCompletedTicketsReducer,
  getVendorApplicationReducer: getVendorApplicationReducer,
  getVendorMonthlyReducer: getVendorMonthlyReducer,
  getVendorSubscriptionCountReducer: getVendorSubscriptionCountReducer,
  downloadLocationsByWarehouseReducer: downloadLocationsByWarehouseReducer,

  //  getPurchaseOrderReducer : getPurchaseOrderNewReducer,
  // createPurchaseOrderReducer : createPurchaseOrderNewReducer,
  // editPurchaseOrderReducer : editPurchaseOrderNewReducer,
  // deletePurchaseOrderReducer : deletePurchaseOrderNewReducer,
  // publishPurchaseOrderReducer : publishPurchaseOrderNewReducer,
  // notAcceptedPurchasedOrdersReducer : notAcceptedPurchasedOrdersNewReducer,
  // getVendorCodeReducer : getVendorCodeNewReducer,
  // acceptPoReducer : acceptPoNewReducer,
  // rejectPoReducer : rejectPoNewReducer,
  // acceptPoBulkReducer : acceptPoBulkNewReducer,
  // rejectPoBulkReducer : rejectPoBulkNewReducer,
  // getReleasedPurchaseOrderReducer : getReleasedPurchaseOrderNewReducer,
  // acceptedPoReducer : acceptedPoNewReducer,
  // unloadingPointForPOReducer : unloadingPointForPONewReducer,
  // deliveryPlantForPOReducer : deliveryPlantForPONewReducer,

  getClientRejectedPurchaseOrdersReducer:
    getClientRejectedPurchaseOrdersReducer,
  getVendorRejectedPurchaseOrdersReducer:
    getVendorRejectedPurchaseOrdersReducer,
  getVendorPurchaseOrderReducer: getVendorPurchaseOrderReducer,

  acceptedPoClientReducer: acceptedPoClientReducer,
  acceptedPoVendorReducer: acceptedPoVendorReducer,
  getAttechmentClientReducer: getAttechmentClientReducer,
  getVendorInvoiceReducer: getVendorInvoiceReducer,
  vendorUploadReducer: vendorUploadReducer,
  vendorDataForDownloadReducer: vendorDataForDownloadReducer,

  getLastFilledDataByVendorIdReducer: getLastFilledDataByVendorIdReducer,

  getResourceGroupReducer: getResourceGroupReducer,

  updateResourceGroupReducer: updateResourceGroupReducer,
  deleteResourceGroupReducer: deleteResourceGroupReducer,
  createNewResourceGroupReducer: createNewResourceGroupReducer,
  getLocationsForResourceGroupReducer: getLocationsForResourceGroupReducer,
  getMachineCenterForDropDownReducer: getMachineCenterForDropDownReducer,
  getMappedMachinesReducer: getMappedMachinesReducer,
  getPoListingReducer: getPoListingReducer,
  getPoListingWithoutPaginationReducer: getPoListingWithoutPaginationReducer,
  getPoProcessLogReducer: getPoProcessLogReducer,
  getCompletedPoListingReducer: getCompletedPoListingReducer,
  getRoutingInfoByPOReducer: getRoutingInfoByPOReducer,
  getPoProcessLogReportsReducer: getPoProcessLogReportsReducer,
  getOperationsListByPOReducer: getOperationsListByPOReducer,
  getOperationsByPoReducer: getOperationsByPoReducer,
  getMachineCenterReducer: getMachineCenterReducer,
  getOperationsReducer: getOperationsReducer,
  getOperationsForDropDownReducer: getOperationsForDropDownReducer,
  getOperationMachineMapReducer: getOperationMachineMapReducer,
  getUserMachineReducer: getUserMachineReducer,
  getUsersForPoReducer: getUsersForPoReducer,
  getLocationsForMachineReducer: getLocationsForMachineReducer,
  getWorkCenterReducer: getWorkCenterReducer,
  getLabelsReducer: getLabelsReducer,
  getLabelsWithPaginationReducer: getLabelsWithPaginationReducer,
  getPrintersForLabelCreationReducer: getPrintersForLabelCreationReducer,
  unReviewInvoiceReducer: unReviewInvoiceReducer,
  reviewInvoiceReducer: reviewInvoiceReducer,
  websocketReducer: websocketReducer,
  paymentStatusReducer: paymentStatusReducer,

  getProductionPlanDownloadReducer: getProductionPlanDownloadReducer,
  getSkuManagementReducer: getSkuManagementReducer,
  getSkuManagementWithoutPaginationReducer:
    getSkuManagementWithoutPaginationReducer,
  getSkuByItemIdReducer: getSkuByItemIdReducer,
  getShipmentReducer: getShipmentReducer,
  getPassPortReducer: getPassPortReducer,
  getPackagingReducer: getPackagingReducer,
  getRepairValueReducer: getRepairValueReducer,
  getReturnsReducer: getReturnsReducer,
  getCustodyReducer: getCustodyReducer,
  getComplianceReducer: getComplianceReducer,
  getDppDocumentsReducer: getDppDocumentsReducer,
  getDppDurabilityReducer: getDppDurabilityReducer,
  getDPPReducer: getDPPReducer,
  getRmTraceReducer: getRmTraceReducer,
  getFgOperationReducer: getFgOperationReducer,
  getFromEnitityReducer: getFromEnitityReducer,
  getUsersForFGReducer: getUsersForFGReducer,
  getBomForPoReducer: getBomForPoReducer,
  getLocationFromReducer: getLocationFromReducer,
  getDppDocumentsImageReducer: getDppDocumentsImageReducer,
  getRepairCenterReducer: getRepairCenterReducer,
  getPOnumberReducer: getPOnumberReducer,
  getPOnumberInsertReducer: getPOnumberInsertReducer,
  getPOnumberFGReducer: getPOnumberFGReducer,

  sendMessageReducer: sendMessageReducer,
  getAllSessionsReducer: getAllSessionsReducer,
  getSessionHistoryReducer: getSessionHistoryReducer,
  getProductsListForDppReducer: getProductsListForDppReducer,
  getAllDataForDppReducer: getAllDataForDppReducer,
  getTechnicalDocumentsReducer: getTechnicalDocumentsReducer,
  getDurabilityReducer: getDurabilityReducer,
  getEnvironmentalReducer: getEnvironmentalReducer,
  getChainOfCustodyReducer: getChainOfCustodyReducer,
  getRawMaterialReducer: getRawMaterialReducer,
  getRepairMaintenanceReducer: getRepairMaintenanceReducer,
  getManufacturingReducer: getManufacturingReducer,
  getPackagingWasteManagementReducer: getPackagingWasteManagementReducer,
  getSkuBySkuTypeReducer: getSkuBySkuTypeReducer,
  getMappedSKUReducer: getMappedSKUReducer,
  getConsumedSuidsReducer: getConsumedSuidsReducer,
  getWoProcessLogReportReducer: getWoProcessLogReportReducer,
  getParentDppCodesReducer: getParentDppCodesReducer,
  getTreeMapReducer:getTreeMapReducer,
  getParentRawCodesReducer: getParentRawCodesReducer,
  getPassPortViewReducer: getPassPortViewReducer,
  getProductVariantReducer: getProductVariantReducer,
  getManufacturerDetailsReducer: getManufacturerDetailsReducer,
  getTensileTestReducer: getTensileTestReducer,
  getHardnessTestReducer: getHardnessTestReducer,
  getNotchImpactTestReducer: getNotchImpactTestReducer,
  getManufacturerReducer: getManufacturerReducer,
  getChemicalAnalysisReducer: getChemicalAnalysisReducer,
  getIndustryTypeReducer: getIndustryTypeReducer,
  getSupplierTypeReducer: getSupplierTypeReducer,
  getAllCareAndUseReducer: getAllCareAndUseReducer,
  getOneCareAndUseReducer: getOneCareAndUseReducer,
  createCareAndUseReducer: createCareAndUseReducer,
  editCareAndUseReducer: editCareAndUseReducer,
  deleteCareAndUseReducer: deleteCareAndUseReducer,
  getAllIndustryReducer: getAllIndustryReducer,
  getOneIndustryReducer: getOneIndustryReducer,
  createIndustryReducer: createIndustryReducer,
  editIndustryReducer: editIndustryReducer,
  deleteIndustryReducer: deleteIndustryReducer,
  getAllSupplierReducer: getAllSupplierReducer,
  getOneSupplierReducer: getOneSupplierReducer,
  createSupplierReducer: createSupplierReducer,
  editSupplierReducer: editSupplierReducer,
  deleteSupplierReducer: deleteSupplierReducer,
  getThermalStabilityTestReducer: getThermalStabilityTestReducer,
  getUsageHistoryReducer: getUsageHistoryReducer,
  getUploadErrorsReducer: getUploadErrorsReducer,
  getProductSpecificationReducer: getProductSpecificationReducer,
});

export default rootReducer;
